module.exports = "/_next/static/images/587f2d8e751b9d3de8497640e7a17e58-belinda-hero-desktop.jpg.webp";